/* eslint-disable @typescript-eslint/no-explicit-any */
import { useCallback, useState } from 'react';
import { fetchQuery } from 'react-relay';
import type { ConcreteRequest, Disposable } from 'relay-runtime';

import JiraRelayEnvironment from '@atlassian/jira-relay-environment';

export function useLoadingState(attributes: any, refetch: any, query: ConcreteRequest): any {
	const [isLoading, setIsLoading] = useState(false);
	const refetchWithoutSuspending: any = useCallback(
		(variables: any) => {
			setIsLoading(true);
			// eslint-disable-next-line @typescript-eslint/no-empty-function
			let disposable: Disposable = { dispose: () => {} };
			const combinedVariables = { ...attributes, ...variables };
			fetchQuery(JiraRelayEnvironment, query, combinedVariables).subscribe({
				complete: () => {
					setIsLoading(false);
					disposable = refetch(combinedVariables, { fetchPolicy: 'store-only' });
				},
			});
			return disposable;
		},
		[refetch, attributes, query],
	);
	return { isLoading, refetchWithoutSuspending };
}
